// extracted by mini-css-extract-plugin
export default {"root":"DraggableActionTarget_root__eAT1D"};